export default __webpack_public_path__ + "static/media/silver_star_with_points.28c2a521.png";